import { FunctionComponent, ReactNode } from 'react';
import {
  ButtonTray,
  ChatButton,
  Content,
  Header,
  Sidebar,
  Wrapper,
} from './components';

export interface MainLayoutProps {
  children: ReactNode;
  headerContent?: FunctionComponent;
  headerAppend?: ReactNode;
  showSidebar?: boolean;
  stickyHeader?: boolean;
  sidebarContent?: ReactNode;
  footer?: ReactNode;
}

const MainLayout: FunctionComponent<MainLayoutProps> = function ({
  children,
  showSidebar = true,
  stickyHeader = true,
  headerContent,
  headerAppend,
  sidebarContent,
  footer,
}) {
  return (
    <div className="relative flex flex-col md:flex-row w-screen md:h-vvp min-h-vvp">
      <Header
        sticky={stickyHeader}
        Logo={headerContent}
        Append={headerAppend}
      />
      <Content showSidebar={showSidebar}>
        <Header
          sticky={stickyHeader}
          showSidebar={showSidebar}
          hideMobile
          Logo={headerContent}
          Append={headerAppend}
        />
        <Wrapper>
          {children}
          {footer && <div className="hidden md:block">{footer}</div>}
        </Wrapper>
      </Content>
      {showSidebar && <Sidebar Content={sidebarContent} />}
      {footer && <div className="block md:hidden">{footer}</div>}
      <ButtonTray>
        <ChatButton />
      </ButtonTray>
    </div>
  );
};

export default MainLayout;
